import React from "react";
import Backdrop from "../Backdrop/Backdrop";
import partyPopper from "../../../assets/partyPopper.svg";
import qrCode from "../../../assets/qrCode.svg";
import styles from "./Transfer.module.scss";

const Transfer = ({ setIsModalOpen }) => {
  return (
    <div className={styles.mainContainer}>
      <Backdrop />
      <div className={styles.container}>
        <span onClick={() => setIsModalOpen(false)}>&times;</span>
        <div className={styles.content}>
          <h2>Who do you want to transfer to?</h2>

          <form>
            <div className={styles.field}>
              <label>SOL Wallet address</label>
              <input type="text" name="address" />
            </div>

            <button>Transfer</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Transfer;
